import { render, staticRenderFns } from "./dashboard-chart.vue?vue&type=template&id=52efafa9&scoped=true&"
import script from "./dashboard-chart.vue?vue&type=script&lang=ts&"
export * from "./dashboard-chart.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-chart.vue?vue&type=style&index=0&id=52efafa9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efafa9",
  null
  
)

export default component.exports